import { CODE_BLOCK } from '../constants';
import { CodeBlockElement } from '../types';

/** Create wrex code block element */
export function createCodeBlock(children: CodeBlockElement['children']): CodeBlockElement {
    return { type: CODE_BLOCK, children };
}
